import React, { useState } from "react";
import { Nav } from "react-bootstrap";
import MessageBox from "./MessageBox";

const MessagesPanel = ({ messages }) => {
    const [filter, setFilter] = useState("Website");
    const handleOnSelect = eventKey => setFilter(eventKey);

    return (
        <>
            <Nav
                variant="pills"
                defaultActiveKey="Website"
                className="mb-2"
                onSelect={handleOnSelect}
            >
                <Nav.Item>
                    <Nav.Link eventKey="Website">Website</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                    <Nav.Link eventKey="Parceria">Partnership</Nav.Link>
                </Nav.Item>

                <Nav.Item>
                    <Nav.Link eventKey="Bug">Bug</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                    <Nav.Link eventKey="Outro">Other</Nav.Link>
                </Nav.Item>
            </Nav>

            {messages.length > 0 ? (
                messages.map((m, i) => {
                    if (m.subject === filter)
                        return <MessageBox key={`message-${i}`} message={m} index={i} />;
                    return null;
                })
            ) : (
                <div><i className="fas fa-inbox"></i> Your mailbox is empty.</div>
            )}
        </>
    );
};

export default MessagesPanel;
